import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class CreditBehaviorService {
  constructor(private http: HttpClientService) {}

  public getCreditBehavior(update): Observable<any> {
    const options = { params: { forced_update: update } };
    return this.http
      .get("/api/credit_behaviors", options)
      .pipe(tap((_) => console.log("CreditBehavior.getCreditBehavior: Ok.")));
  }

  public getCreditBehaviorDownloadLinks(): Observable<any> {
    return this.http
      .get("/api/credit_behaviors/download_reports")
      .pipe(tap((_) => console.log("CreditBehavior.getCreditBehaviorDownloadLinks: Ok.")));
  }

  public createReport(date): Observable<any> {
    const params = { date: date };
    return this.http
      .post("/api/credit_behaviors/create_report", params)
      .pipe(tap((_) => console.log("CreditBehavior.createReport: Ok.")));
  }

  public getContributions(): Observable<any> {
    return this.http
      .get("/api/account_modifications/contributions")
      .pipe(tap((_) => console.log("CreditBehavior.getContributions: Ok.")));
  }

  public getRegimenes(): Observable<any> {
    return this.http.get("/api/accounts/regime").pipe(tap((_) => console.log("CreditBehavior.getRegimenes: Ok.")));
  }

  public getOutstanding(): Observable<any> {
    return this.http
      .get("/api/accounts/outstanding")
      .pipe(tap((_) => console.log("CreditBehavior.getOutstanding: Ok.")));
  }
}
